import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0769304e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0769304e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0769304e",
  null
  
)

export default component.exports